import React from 'react';
import '../../styles/landing/landing.scss';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import Footer from '../includes/Footer';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import axios from 'Axios';
import Snackbar from 'ServerErrorSnackbar';
import styled from 'styled-components';

const ValidateMsg = styled.div``;

class ContactUs extends React.Component {
  state = {
    topic: '',
    name: '',
    email: '',
    query: '',
    SnackbarOpen: false,
    SnackbarMsg: false,
  };

  handleChangeDropdown = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleCloseServerErrorSnackbar = () => {
    this.setState({ SnackbarOpen: false });
  };
  handleOpenServerErrorSnackbar = () => {
    this.setState({ SnackbarOpen: true });
  };
  handleEraseServerError = () => {
    this.setState({ SnackbarMsg: false });
  };
  isValid = () => {
    return !(
      this.state.email !== '' &&
      this.state.query !== '' &&
      this.state.name !== ''
    );
  };
  sendMail = () => {
    axios
      .post('contact', {
        email: this.state.email,
        name: this.state.name,
        body: this.state.query,
      })
      .then(response => {
        if (response.data) {
          this.setState(
            {
              name: '',
              email: '',
              query: '',
              SnackbarMsg: 'The query has been sent',
            },
            () => {
              this.handleOpenServerErrorSnackbar();
            }
          );
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          // console.log('error.request', error.request);
          errorMessage = error.request;
        } else {
          // console.log('error.message', error.message);
          errorMessage = error.message;
        }
        this.setState(
          {
            SnackbarMsg: errorMessage,
          },
          () => {
            this.handleOpenServerErrorSnackbar();
          }
        );
      });
  };

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            maxWidth: '1024px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Grid
            spacing={0}
            container
            //alignItems={'center'}
            justify={'center'}
            spacing={0}
            className="template-terms"
          >
            <Grid
              item
              lg={12}
              md={7}
              sm={9}
              xs={10}
              className="u-pad-bot-30 info-main"
            >
              <h1 className="template-terms-main-title">Contact us</h1>
              <Grid
                spacing={0}
                container
                //alignItems={'center'}
                justify={'center'}
                spacing={0}
                className=""
              >
                <Grid item md={3} sm={12} className="w100 u-pad-r-10">
                  <span className="t-primary-20 t-weight-b">Stuck?</span>
                  <p className="t-primary-18 u-mrg-bot-10">
                    We are here for you
                  </p>
                  <p className="t-secondary-13 u-pad-r-40">
                    If you need any help please drop us a line by using the form
                    below. Please{' '}
                    <Link className="text-link-regular" to="/faq">
                      search the FAQ 
                    </Link>{' '}
                    for the answer before submitting a question.
                  </p>
                </Grid>
                <Grid item md={9} sm={12} className="w100">
                  <Grid
                    spacing={0}
                    container
                    //alignItems={'center'}
                    spacing={0}
                    className=""
                  >
                    <Grid item md={6} xs={12} className="">
                      <p>
                        If you need any help please drop us a line by using the
                        below form!
                      </p>
                      {/* <FormControl fullWidth className="">
                    <InputLabel
                      htmlFor="topic"
                      classes={{
                        root: 'label--c-gray',
                      }}
                    >
                      Choose topic
                    </InputLabel>
                    <Select
                      value={this.state.topic}
                      onChange={this.handleChange}
                      inputProps={{
                        name: 'topic',
                        id: 'topic',
                      }}
                      classes={{
                        select: 'underline--c-black',
                      }}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl> */}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    //alignItems={'center'}
                    spacing={8}
                    className=""
                  >
                    <Grid item xs={6} className="">
                      <FormControl fullWidth className="u-mrg-top-20">
                        <InputLabel
                          htmlFor="Name"
                          classes={{
                            root: 'label--c-gray',
                          }}
                        >
                          Name
                        </InputLabel>
                        <Input
                          classes={{
                            underline: 'underline--c-black',
                          }}
                          id="name"
                          type="text"
                          label="Name"
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} className="">
                      <FormControl fullWidth className="u-mrg-top-20">
                        <InputLabel
                          htmlFor="Email"
                          classes={{
                            root: 'label--c-gray',
                          }}
                        >
                          Your email
                        </InputLabel>
                        <Input
                          classes={{
                            underline: 'underline--c-black',
                          }}
                          id="email"
                          type="text"
                          label="Email"
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} className="">
                      <FormControl fullWidth className="u-mrg-top-20">
                        <InputLabel
                          htmlFor="query"
                          classes={{
                            root: 'label--c-gray',
                          }}
                        >
                          Your query
                        </InputLabel>
                        <Input
                          classes={{
                            underline: 'underline--c-black',
                          }}
                          multiline
                          id="query"
                          type="text"
                          label="Query"
                          value={this.state.query}
                          onChange={this.handleChange('query')}
                        />
                      </FormControl>
                      <Grid item xs={6} className="">
                        <Button
                          disabled={this.isValid()}
                          variant="contained"
                          color="primary"
                          fullWidth
                          className="u-mrg-top-50 t-weight-b"
                          onClick={this.sendMail}
                        >
                          Submit query
                        </Button>
                      </Grid>{' '}
                      <Grid item xs={6} className="">
                        {this.isValid() ? (
                          <ValidateMsg>
                            You must fill the form for submiting
                          </ValidateMsg>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Footer />
        <Snackbar
          open={this.state.SnackbarOpen}
          message={this.state.SnackbarMsg}
          onClose={this.handleCloseServerErrorSnackbar}
          handleEraseServerError={this.handleEraseServerError}
        />
      </React.Fragment>
    );
  }
}

export default ContactUs;
